import { NgModule } from "@angular/core";
import { AucUserService } from "@auction-ui/services/user.service";
import { AucAuctionService } from "./auction.service";
import { AucFeatureService } from "./feature.service";
import { AucSideMenuService } from "./side.menu.service";

@NgModule({
  imports: [
  ],
  providers: [
    AucFeatureService,
    AucSideMenuService,
    AucUserService,
    AucAuctionService,
  ]
})
export class AucServiceModule { }